import { render, staticRenderFns } from "./AfterRecipeCard.vue?vue&type=template&id=4b02fe63&"
import script from "./AfterRecipeCard.vue?vue&type=script&lang=js&"
export * from "./AfterRecipeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports